import { convertISTToTimezone } from "../../components/appointment/utils/date";
import { cleanText } from "../../components/appointment/utils/doctorDisplay";
const DISPLAY_DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
const DISPLAY_MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
export function formatDateStr(date) {
    const y = String(date.getFullYear()).padStart(4, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
}
export function isToday(date) {
    const today = new Date();
    return (date.getFullYear() === today.getFullYear() &&
        date.getMonth() === today.getMonth() &&
        date.getDate() === today.getDate());
}
export function formatDateDisplay(date) {
    const day = DISPLAY_DAYS[date.getDay()];
    const month = DISPLAY_MONTHS[date.getMonth()];
    return `${day}, ${month} ${date.getDate()}`;
}
function extractHHMM(value) {
    if (!value)
        return "";
    const withoutDate = value.includes("T") ? value.split("T")[1] : value;
    return (withoutDate ?? "").substring(0, 5);
}
export function formatShiftRange(slot, date, timezone) {
    if (!slot?.start || !slot?.end)
        return "";
    const dateStr = formatDateStr(date);
    const startHHMM = extractHHMM(slot.start);
    const endHHMM = extractHHMM(slot.end);
    if (!startHHMM || !endHHMM)
        return "";
    const displayStart = convertISTToTimezone(startHHMM, dateStr, timezone);
    const displayEnd = convertISTToTimezone(endHHMM, dateStr, timezone);
    return `${displayStart} – ${displayEnd}`;
}
export function buildQueueToken(state, issued) {
    const patientName = state.selectedPatient
        ? `${state.selectedPatient.firstName} ${state.selectedPatient.lastName}`.trim()
        : state.newPatientForm.fullName.trim();
    const tokenNumber = String(issued.tokenDisplay ||
        issued.tokenNumber ||
        `Q-${String(issued.id || 0).padStart(3, "0")}`);
    return {
        tokenNumber,
        queuePosition: issued.queuePosition || 0,
        estimatedWaitTime: issued.estimatedWaitTime || 0,
        patientName,
        appointmentDate: formatDateStr(state.selectedDate),
        appointmentTime: state.selectedSlot?.start,
        dateDisplay: formatDateDisplay(state.selectedDate),
        timeDisplay: formatShiftRange(state.selectedSlot, state.selectedDate, state.selectedTimezone),
        doctorName: state.selectedDoctor
            ? cleanText(state.doctorDisplayByDoctorId[state.selectedDoctor.id]?.name) ?? undefined
            : undefined,
        locationName: state.workspace?.addresses.find((a) => a.id === state.selectedAddressId)?.city,
        bookingType: isToday(state.selectedDate) ? "TODAY" : "FUTURE",
    };
}
